import moment from 'moment';
import { FiChevronDown } from 'react-icons/fi';

export default function TransmissionDetailsTable({ data = [], setSelectedTransmission, selectedTransmission, kpis: detailKpis }) {
  const kpis = [
    {
      id: 1,
      title: 'Número de transmissões',
      value: detailKpis?.['transmissions_count'],
      variation: 'report-kpi-card--video'
    },
    {
      id: 2,
      title: 'Horas de transmissão',
      value: detailKpis?.['total_transmitted_hours'],
      variation: 'report-kpi-card--clock'
    }
  ];

  return (
    <div className="round-dg-wrapper">
      <div className="mb-6 flex gap-2 border-b border-neutral-lightest pb-3">
        <span className="text-neutral-light">Aulas</span>
        <span
          onClick={() => {
            setSelectedTransmission(null);
          }}
          className="card__icon-wrapper card__icon-wrapper--sm u-cursor-pointer"
        >
          <FiChevronDown
            style={{ transform: 'rotate(90deg)' }}
            className="card__icon"
          />
        </span>
        <span className="font-semibold text-primary-dark">{selectedTransmission?.title}</span>
      </div>
      <div className="rounded-2xl bg-neutral-bright p-4">
        <div className="report-kpi-card-wrapper mb-6">
          {kpis.map(kpi => (
            <div
              className={`report-kpi-card ${kpi.variation}`}
              key={kpi.id}
            >
              <h3 className="report-kpi-card__title font-semibold text-primary-dark">{kpi.title}</h3>
              <p
                className="report-kpi-card__value"
                title={kpi.value}
              >
                {kpi.value}
              </p>
            </div>
          ))}
        </div>

        <table
          className="round-dg round-dg--light"
          style={{ minWidth: '564px' }}
        >
          <thead className="round-dg__header">
            <tr className="round-dg__row">
              <th className="round-dg__cell-header round-dg__cell-header--sm">Data/hora de início</th>

              <th className="round-dg__cell-header round-dg__cell-header--sm">Data/hora de fim</th>
              <th className="round-dg__cell-header round-dg__cell-header--sm u-text-right">Duração</th>
            </tr>
          </thead>

          <tbody className="round-dg__body">
            {data?.map((item, i) => (
              <tr className="round-dg__row round-dg__row--clickable">
                <th className="round-dg__cell-header round-dg__cell-header--sm round-dg__cell-header--row">
                  {moment(item.initial_date).format('DD/MM/YYYY')} às {moment(item.initial_date).format('HH:mm')}
                </th>
                <th className="round-dg__cell-header round-dg__cell-header--sm round-dg__cell-header--row">
                  {moment(item.end_date).format('DD/MM/YYYY')} às {moment(item.end_date).format('HH:mm')}
                </th>

                <td className="round-dg__cell round-dg__cell--sm u-text-right">{item.duration}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
